<template>
  <div class="page activity">
    <div class="kpi-row">
      <div class="kpi" @click="openActivitiesKpi">
        <div class="kpi__left">
          <span class="kpi__icon-wrap">
            <i class="ri-calendar-event-fill kpi__icon" aria-hidden="true" />
          </span>
          <span class="kpi__label">年活动数</span>
        </div>
        <b>{{ kpiInt("activities") }}<em>场</em></b>
      </div>
      <div class="kpi kpi--green" @click="openVolunteerKpi">
        <div class="kpi__left">
          <span class="kpi__icon-wrap kpi__icon-wrap--green">
            <i class="ri-timer-fill kpi__icon" aria-hidden="true" />
          </span>
          <span class="kpi__label">公益时长</span>
        </div>
        <b>{{ kpiInt("volunteerHours") }}<em>小时</em></b>
      </div>
      <div class="kpi kpi--green" @click="openServedKpi">
        <div class="kpi__left">
          <span class="kpi__icon-wrap kpi__icon-wrap--green">
            <i class="ri-heart-fill kpi__icon" aria-hidden="true" />
          </span>
          <span class="kpi__label">服务群众数</span>
        </div>
        <b>{{ kpiInt("served") }}<em>人</em></b>
      </div>
      <div class="kpi kpi--rate" @click="openSandanRate">
        <div class="kpi__left">
          <span class="kpi__icon-wrap kpi__icon-wrap--rate">
            <i class="ri-checkbox-circle-fill kpi__icon" aria-hidden="true" />
          </span>
          <span class="kpi__label">三单办结率</span>
        </div>
        <div class="rate-ring" :style="sandanRingStyle">
          <strong>{{ kpiInt("sandanRate") }}%</strong>
        </div>
      </div>
      <div class="kpi" @click="openBrandKpi">
        <div class="kpi__left">
          <span class="kpi__icon-wrap">
            <i class="ri-award-fill kpi__icon" aria-hidden="true" />
          </span>
          <span class="kpi__label">品牌参与数</span>
        </div>
        <b>{{ kpiInt("brandParticipants") }}<em>人次</em></b>
      </div>
    </div>

    <div class="cols">
      <div class="col col--left">
        <section class="panel panel--cal">
          <div class="cal-head">
            <button type="button" @click="shiftMonth(-1)">‹</button>
            <h3>{{ calLabel }}</h3>
            <button type="button" @click="shiftMonth(1)">›</button>
          </div>
          <div class="cal-legend">
            <span v-for="leg in calLegend" :key="leg.key">
              <i :class="'dot-' + leg.key" />{{ leg.label }}
            </span>
          </div>
          <div class="cal-week">
            <span v-for="w in weekLabels" :key="w">{{ w }}</span>
          </div>
          <div class="cal-grid">
            <button
              v-for="(cell, i) in calCells"
              :key="i"
              type="button"
              class="cal-day"
              :class="{
                empty: !cell.day,
                today: cell.isToday && cell.count > 0,
                has: cell.count > 0,
                active: cell.day === selectedDay
              }"
              :disabled="!cell.day"
              @click="selectDay(cell)"
            >
              <span v-if="cell.day" class="cal-num">
                <i
                  v-for="(d, di) in cell.dots || []"
                  :key="di"
                  class="cal-ring"
                  :class="'dot-' + d"
                  :style="{ '--i': di }"
                />
                <em>{{ cell.day }}</em>
              </span>
            </button>
          </div>
        </section>

        <section class="panel panel--list">
          <h3>公益项目</h3>
          <el-scrollbar class="list-scroll">
            <ul>
              <li
                v-for="(v, i) in volunteerProjects"
                :key="i"
                @click="openVolunteer(v)"
              >
                <strong>{{ v.title || v.Title }}</strong>
                <span
                  >{{ v.Num1 || v.num1 || 0 }} 小时 · 志愿者
                  {{ v.Num2 || v.num2 || 0 }} 人 · 服务
                  {{ v.Num3 || v.num3 || 0 }} 人</span
                >
              </li>
              <li v-if="!volunteerProjects.length" class="empty">暂无公益项目</li>
            </ul>
          </el-scrollbar>
        </section>

        <section class="panel panel--chart">
          <h3>三单办结趋势</h3>
          <div ref="trendChart" class="chart"></div>
          <p class="trend-foot">{{ sandanTrendFoot }}</p>
        </section>
      </div>

      <div class="col col--mid">
        <section class="panel panel--cases">
          <h3>三单典型案例</h3>
          <el-scrollbar class="cases-scroll">
            <div class="cases">
              <button
                v-for="(c, i) in cases"
                :key="'c' + i"
                type="button"
                class="case-card"
                @click="openCase(c)"
              >
                <h4 class="case-card__title">{{ c.title }}</h4>
                <div class="case-card__member">
                  <div
                    class="case-card__avatar"
                    :style="caseAvatarStyle(c)"
                  >
                    <span v-if="!caseAvatarUrl(c)">{{
                      (c.author || "会").slice(0, 1)
                    }}</span>
                  </div>
                  <span class="case-card__name">{{ c.author || "接单会员" }}</span>
                  <em v-if="c.expertise" class="case-card__tag">{{
                    c.expertise
                  }}</em>
                  <span v-if="c.rating > 0" class="case-card__stars">{{
                    "★".repeat(c.rating)
                  }}</span>
                </div>
                <p v-if="c.result" class="case-card__result">{{ c.result }}</p>
              </button>
              <p v-if="!cases.length" class="empty">暂无案例</p>
            </div>
          </el-scrollbar>
        </section>

        <section class="panel panel--cases">
          <h3>助企服务案例</h3>
          <el-scrollbar class="cases-scroll">
            <div class="cases">
              <button
                v-for="(c, i) in enterpriseCases"
                :key="'e' + i"
                type="button"
                class="ent-card"
                @click="openEnterpriseCase(c)"
              >
                <span class="ent-card__tag">{{ c.tag || "科创青岛" }}</span>
                <h4 class="ent-card__company">{{
                  c.companyName || c.title || "企业"
                }}</h4>
                <p v-if="c.demand || c.content" class="ent-card__demand">{{
                  c.demand || c.content
                }}</p>
                <p class="ent-card__expert">{{ enterpriseExpertLine(c) }}</p>
                <p v-if="c.result" class="ent-card__result">{{ c.result }}</p>
                <p v-if="c.feedback" class="ent-card__feedback">{{
                  c.feedback
                }}</p>
              </button>
              <p v-if="!enterpriseCases.length" class="empty">暂无助企案例</p>
            </div>
          </el-scrollbar>
        </section>
      </div>

      <div class="col col--right">
        <section class="panel panel--vols">
          <h3>星级志愿者</h3>
          <el-scrollbar class="vols-scroll">
            <div class="vols">
              <button
                v-for="(v, i) in volunteers"
                :key="i"
                type="button"
                class="vol-card"
                :class="{ 'vol-card--gold': v.star >= 5 }"
                @click="openVolunteerPerson(v)"
              >
                <div
                  class="vol-card__avatar"
                  :style="volAvatarStyle(v)"
                >
                  <span v-if="!volAvatarUrl(v)">{{
                    (v.name || "?").slice(0, 1)
                  }}</span>
                </div>
                <div class="vol-card__body">
                  <strong>{{ v.name }}</strong>
                  <div class="vol-card__meta">
                    <em>{{ v.hours }} 小时</em>
                    <span class="star-row">
                      <i
                        v-for="n in 5"
                        :key="n"
                        :class="{ on: n <= v.star }"
                        >★</i
                      >
                    </span>
                  </div>
                </div>
              </button>
              <p v-if="!volunteers.length" class="empty">
                暂无星级志愿者（公益台账须选本会志愿者，每人累计 100+ 小时）
              </p>
            </div>
          </el-scrollbar>
        </section>

        <section class="panel panel--works">
          <h3>品牌作品</h3>
          <div
            class="works"
            @mouseenter="worksPaused = true"
            @mouseleave="worksPaused = false"
          >
            <div v-if="works.length" class="works__viewport">
              <div class="works__track" :style="worksTrackStyle">
                <button
                  v-for="(w, i) in works"
                  :key="'work-' + i"
                  type="button"
                  class="works__slide"
                  @click="openLightbox(works, i)"
                >
                  <div
                    class="works__img"
                    :style="workImgStyle(w)"
                  />
                  <div class="works__cap">
                    <strong>{{ w.title }}</strong>
                  </div>
                </button>
              </div>
            </div>
            <p v-else class="empty">暂无品牌作品（后台：轮播管理，类型选「品牌作品」并选分会）</p>
            <div v-if="works.length > 1" class="works__dots">
              <i
                v-for="(w, i) in works"
                :key="'wd-' + i"
                :class="{ on: i === worksIndex }"
                @click="worksIndex = i"
              />
            </div>
          </div>
        </section>
      </div>
    </div>

    <div v-if="lightbox.open" class="lb" @click.self="closeLightbox">
      <button type="button" class="lb__nav lb__prev" @click="lightboxPrev">‹</button>
      <div class="lb__body">
        <img
          v-if="lbItem.coverUrl"
          :src="absUrl(lbItem.coverUrl)"
          :alt="lbItem.title"
        />
        <div v-else class="lb__placeholder">{{ lbItem.title }}</div>
        <p>{{ lbItem.title }}</p>
      </div>
      <button type="button" class="lb__nav lb__next" @click="lightboxNext">›</button>
      <button type="button" class="lb__close" @click="closeLightbox">×</button>
    </div>
  </div>
</template>

<script>
import { LineChart } from "@/plugins/echarts_bank/index";
import branchQuery from "@/utils/branchQuery";
import { absMediaUrl, toDetailItem, memberAvatarUrl } from "@/utils/mediaUrl";
import { isSameJson } from "@/utils/stableData";
import dashPage from "@/mixins/dashPage";

const WEEK = ["日", "一", "二", "三", "四", "五", "六"];

/** 学习蓝、公益绿、三单橙、品牌红、会议紫 */
const DOT_ORDER = ["blue", "green", "orange", "red", "purple"];

function catDot(cat) {
  const c = cat || "";
  if (c.includes("公益")) return "green";
  if (c.includes("三单")) return "orange";
  if (
    c.includes("品牌") ||
    c.includes("寻美") ||
    c.includes("新善") ||
    c.includes("科创")
  ) {
    return "red";
  }
  if (c.includes("会议")) return "purple";
  if (c.includes("学习")) return "blue";
  return "blue";
}

function uniqueDots(categories) {
  const set = new Set((categories || []).map(catDot));
  return DOT_ORDER.filter(k => set.has(k));
}

export default {
  name: "DashActivity",
  mixins: [branchQuery, dashPage],
  data() {
    const now = new Date();
    return {
      payload: {},
      chart: null,
      calYear: now.getFullYear(),
      calMonth: now.getMonth() + 1,
      selectedDay: null,
      weekLabels: WEEK,
      calLegend: [
        { key: "blue", label: "学习" },
        { key: "green", label: "公益" },
        { key: "orange", label: "三单" },
        { key: "red", label: "品牌" },
        { key: "purple", label: "会议" }
      ],
      worksIndex: 0,
      worksPaused: false,
      worksTimer: null,
      trendSig: null,
      worksSig: null
    };
  },
  computed: {
    kpis() {
      return this.payload.kpis || {};
    },
    sandanRingStyle() {
      const r = Math.min(100, Number(this.kpis.sandanRate) || 0);
      return {
        background: `conic-gradient(#ff5a5a 0 ${r}%, rgba(255,255,255,0.12) ${r}% 100%)`
      };
    },
    volunteerAll() {
      return this.payload.volunteer || [];
    },
    /** 白皮书：当年开展的重点公益项目 */
    volunteerProjects() {
      const year = new Date().getFullYear();
      return this.volunteerAll
        .filter(v => {
          const featured = !!(v.isFeatured || v.IsFeatured);
          if (!featured) return false;
          const d = this.parseActivityDate(v.occurredAt || v.OccurredAt || v.time);
          return d && d.getFullYear() === year;
        })
        .slice()
        .sort((a, b) => {
          const ha = Number(a.Num1 != null ? a.Num1 : a.num1) || 0;
          const hb = Number(b.Num1 != null ? b.Num1 : b.num1) || 0;
          return hb - ha;
        });
    },
    cases() {
      return this.payload.cases || [];
    },
    enterpriseCases() {
      return this.payload.enterpriseCases || [];
    },
    volunteers() {
      const list = this.payload.volunteers || [];
      if (this.inspectMode) {
        return list.filter(v => Number(v.star) >= 4);
      }
      return list;
    },
    works() {
      const slides = [];
      (this.payload.works || []).forEach(w => {
        const urls = [];
        const add = u => {
          const url = String(u || "").trim();
          if (!url || urls.indexOf(url) >= 0) return;
          urls.push(url);
        };
        const gallery = w.galleryUrls || w.GalleryUrls || [];
        if (Array.isArray(gallery) && gallery.length) {
          gallery.forEach(add);
        } else {
          add(w.coverUrl || w.CoverUrl);
          const raw = w.galleryText || w.GalleryText || "";
          if (raw) {
            String(raw)
              .split(/[\n,;|，；]+/)
              .forEach(add);
          }
        }
        const base = {
          title: w.title || "",
          author: w.author || "",
          category: w.category || "品牌作品",
          content: w.content || "",
          time: w.time || ""
        };
        if (!urls.length) {
          slides.push({ ...base, coverUrl: "" });
          return;
        }
        urls.forEach(url => {
          slides.push({ ...base, coverUrl: url });
        });
      });
      return slides;
    },
    worksTrackStyle() {
      return {
        transform: `translateX(-${this.worksIndex * 100}%)`
      };
    },
    calLabel() {
      return `${this.calYear}年${this.calMonth}月`;
    },
    dayMap() {
      const map = {};
      const add = (rawDate, item, cat) => {
        const d = this.parseActivityDate(rawDate);
        if (!d) return;
        if (d.getFullYear() !== this.calYear || d.getMonth() + 1 !== this.calMonth) {
          return;
        }
        const day = d.getDate();
        if (!map[day]) map[day] = { count: 0, categories: [], items: [] };
        map[day].count += 1;
        const category = cat || item.category || "其他";
        if (!map[day].categories.includes(category)) {
          map[day].categories.push(category);
        }
        map[day].items.push({ ...item, category });
      };

      // 会议培训（原活动管理，仅此类）
      (this.payload.activities || []).forEach(a => {
        add(a.time || a.occurredAt, {
          title: a.title,
          content: a.content,
          category: "会议培训",
          time: a.time,
          coverUrl: a.coverUrl,
          status: a.status,
          participants: a.participants
        }, "会议培训");
      });

      // 学习教育台账
      (this.payload.learning || []).forEach(l => {
        const time = (l.occurredAt || l.OccurredAt || l.time || "")
          .toString()
          .slice(0, 10);
        add(time || l.occurredAt || l.OccurredAt, {
          title: l.title || l.Title,
          content: l.content || l.Content,
          category: "学习教育",
          time,
          coverUrl: l.coverUrl || l.CoverUrl,
          status: l.status || l.Status,
          participants: l.num1 || l.Num1 || l.participants || 0
        }, "学习教育");
      });

      // 三单（白皮书日历含三单橙点）
      (this.payload.sandan || []).forEach(s => {
        const time = (s.occurredAt || s.OccurredAt || s.time || "")
          .toString()
          .slice(0, 10);
        add(time || s.occurredAt || s.OccurredAt, {
          title: s.title || s.Title,
          content: s.content || s.Content,
          category: "三单服务",
          time,
          coverUrl: s.coverUrl || s.CoverUrl,
          status: s.status || s.Status,
          participants: s.num3 || s.Num3 || 0
        }, "三单服务");
      });

      // 公益项目
      (this.payload.volunteer || []).forEach(v => {
        const time = (v.occurredAt || v.OccurredAt || "")
          .toString()
          .slice(0, 10);
        add(time || v.occurredAt || v.OccurredAt, {
          title: v.title || v.Title,
          content: v.content || v.Content,
          category: "公益服务",
          time,
          coverUrl: v.coverUrl || v.CoverUrl,
          status: `${v.Num1 || v.num1 || 0} 小时`,
          participants: v.Num3 || v.num3 || 0
        }, "公益服务");
      });

      // 品牌活动（品牌红点）
      (this.payload.brand || []).forEach(b => {
        const time = (b.occurredAt || b.OccurredAt || b.time || "")
          .toString()
          .slice(0, 10);
        add(time || b.occurredAt || b.OccurredAt, {
          title: b.title || b.Title,
          content: b.content || b.Content,
          category: "品牌活动",
          time,
          coverUrl: b.coverUrl || b.CoverUrl,
          status: b.status || b.Status,
          participants: b.num2 || b.Num2 || 0
        }, "品牌活动");
      });

      return map;
    },
    calCells() {
      const y = this.calYear;
      const m = this.calMonth;
      const first = new Date(y, m - 1, 1);
      const days = new Date(y, m, 0).getDate();
      const start = first.getDay();
      const today = new Date();
      const cells = [];
      for (let i = 0; i < start; i++) cells.push({ day: 0, dots: [] });
      for (let d = 1; d <= days; d++) {
        const info = this.dayMap[d] || { count: 0, categories: [] };
        const dots = uniqueDots(info.categories);
        if (!dots.length && info.count > 0) dots.push("blue");
        cells.push({
          day: d,
          count: info.count || 0,
          dots,
          isToday:
            today.getFullYear() === y &&
            today.getMonth() + 1 === m &&
            today.getDate() === d
        });
      }
      while (cells.length % 7) cells.push({ day: 0, dots: [] });
      return cells;
    },
    lbItem() {
      return this.lightbox.list[this.lightbox.index] || {};
    },
    sandanTrendFoot() {
      const st = this.payload.sandanStats || {};
      const hours = st.avgResponseHours;
      const sat =
        st.satisfactionRate != null
          ? st.satisfactionRate
          : st.satisfactionAvg != null
            ? Math.round((Number(st.satisfactionAvg) / 5) * 100)
            : null;
      const a =
        hours != null && hours !== ""
          ? `平均响应 ${hours} 小时`
          : "平均响应 —";
      const b = sat != null ? `群众满意度 ${sat}%` : "群众满意度 —";
      return `${a}，${b}`;
    }
  },
  watch: {
    branchQuery: {
      deep: true,
      handler() {
        this.load();
      }
    },
    payload() {
      this.redrawIfChanged("trendSig", this.payload.sandanTrend || [], () => {
        this.$nextTick(this.renderTrend);
      });
      const k = this.payload.kpis || {};
      this.syncRollKpis({
        activities: k.activities || 0,
        volunteerHours: k.volunteerHours || 0,
        served: k.served || 0,
        sandanRate: k.sandanRate || 0,
        brandParticipants: k.brandParticipants || 0
      });
      const works = this.payload.works || [];
      if (!isSameJson(works, this.worksSig)) {
        this.worksSig = works;
        this.worksIndex = 0;
        this.startWorksAutoplay();
      }
    }
  },
  mounted() {
    const fs = this.commonFont || 14;
    this.chart = new LineChart({
      ele: this.$refs.trendChart,
      fontSize: fs,
      unit: "%",
      fontColor: "#A6BFFF",
      lineColor: "#233F8C",
      palletColors: [["#00c3ff", "#4c7dff"]],
      grid: {
        top: 2.6 * fs,
        right: 1.2 * fs,
        bottom: 0.6 * fs,
        left: 0.8 * fs,
        containLabel: true
      },
      yAxis: {
        min: 0,
        max: 100,
        splitNumber: 5
      },
      series: [
        {
          name: "办结率",
          smooth: true,
          showSymbol: true,
          symbolSize: 8,
          label: {
            show: true,
            position: "top",
            distance: 4,
            fontSize: Math.max(10, fs - 2),
            color: "#00c3ff",
            formatter(p) {
              const v = p.value;
              return v == null || v === "" ? "" : `${v}%`;
            }
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(0,195,255,0.35)" },
                { offset: 1, color: "rgba(0,195,255,0.02)" }
              ]
            }
          }
        }
      ]
    });
    this.load();
    this.startPageRefresh();
    this.startWorksAutoplay();
  },
  beforeDestroy() {
    if (this.chart) this.chart.destroy();
    this.stopWorksAutoplay();
  },
  methods: {
    absUrl: absMediaUrl,
    workImgStyle(w) {
      const url = this.absUrl((w && w.coverUrl) || "");
      if (!url) return {};
      return { backgroundImage: `url("${url}")` };
    },
    /** 活动日期：优先按 yyyy-MM-dd 本地解析，避免 UTC 串日 */
    parseActivityDate(raw) {
      if (!raw) return null;
      if (raw instanceof Date) {
        return Number.isNaN(raw.getTime()) ? null : raw;
      }
      const s = String(raw).trim();
      const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) {
        const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
        return Number.isNaN(d.getTime()) ? null : d;
      }
      const d = new Date(s);
      return Number.isNaN(d.getTime()) ? null : d;
    },
    async load() {
      const res = await this.$api("screen", "activity", this.branchQuery);
      if (res && res.code === 0) {
        if (isSameJson(this.payload, res)) return;
        this.payload = res;
      }
    },
    renderTrend() {
      if (!this.chart) return;
      const trend = this.payload.sandanTrend || [];
      const points = trend.length
        ? trend.map(t => ({
            name: t.name || t.month,
            value: Number(t.rate) || 0,
            month: t.month,
            total: t.total || 0,
            done: t.done || 0,
            cases: t.cases || []
          }))
        : [{ name: "—", value: 0, month: "", total: 0, done: 0, cases: [] }];

      this.chart
        .updateOption(
          {
            tooltip: {
              trigger: "axis",
              formatter(res) {
                const item = (res && res[0]) || {};
                const row = points[item.dataIndex] || {};
                const label = row.month || item.name || "";
                return `${label} 办结率 ${row.value != null ? row.value : item.value}%（办结 ${row.done || 0}/${row.total || 0}）`;
              }
            }
          },
          false
        )
        .setData([points])
        .draw();

      this.$nextTick(() => {
        if (this.chart && this.chart.resize) this.chart.resize();
        this.bindTrendClick(points);
      });
    },
    bindTrendClick(points) {
      const ec = this.chart && this.chart._chart;
      if (!ec || !ec.on) return;
      ec.off("click");
      ec.on("click", params => {
        if (params == null || params.dataIndex == null) return;
        const row = points[params.dataIndex];
        if (!row) return;
        this.openSandanTrendMonth(row);
      });
    },
    openSandanTrendMonth(row) {
      const cases = row.cases || [];
      const items = cases.length
        ? cases.map(c =>
            toDetailItem({
              title: c.title || c.Title,
              content: c.content || c.Content || "",
              status: c.status || c.Status,
              author: c.author || c.Author,
              time: c.time || "",
              coverUrl: c.coverUrl || c.CoverUrl
            })
          )
        : [
            toDetailItem({
              title: "暂无典型案例",
              content: "该月暂无三单案例，可在后台标记重点三单"
            })
          ];
      this.openDrawer({
        title: `${row.month || row.name || ""} 三单办结`,
        summary: [
          `三单 ${row.total || 0} 件`,
          `办结 ${row.done || 0} 件`,
          `办结率 ${row.value != null ? row.value : 0}%`
        ],
        sections: [{ title: "典型案例", items }]
      });
    },
    shiftMonth(delta) {
      let m = this.calMonth + delta;
      let y = this.calYear;
      if (m < 1) {
        m = 12;
        y -= 1;
      } else if (m > 12) {
        m = 1;
        y += 1;
      }
      this.calYear = y;
      this.calMonth = m;
      this.selectedDay = null;
    },
    selectDay(cell) {
      if (!cell.day) return;
      this.selectedDay = cell.day;
      const info = this.dayMap[cell.day] || { items: [] };
      const items = (info.items || []).map(a =>
        toDetailItem({
          title: a.title,
          content: a.content || `参与 ${a.participants || 0} 人`,
          category: a.category,
          time: a.time,
          coverUrl: a.coverUrl,
          status: a.status
        })
      );
      this.openDrawer({
        title: `${this.calLabel}${cell.day}日活动`,
        summary: [`共 ${items.length} 场`],
        items: items.length
          ? items
          : [
              toDetailItem({
                title: "该日暂无活动",
                content: "该日没有已上屏的学习 / 公益 / 三单 / 品牌 / 会议记录。"
              })
            ]
      });
    },
    startWorksAutoplay() {
      this.stopWorksAutoplay();
      this.worksTimer = setInterval(() => {
        if (this.worksPaused || this.lightbox.open || this.works.length <= 1) return;
        this.worksIndex = (this.worksIndex + 1) % this.works.length;
      }, 3000);
    },
    stopWorksAutoplay() {
      if (this.worksTimer) {
        clearInterval(this.worksTimer);
        this.worksTimer = null;
      }
    },
    openActivitiesKpi() {
      // 与首页「某类型 · 活动列表」同一套 items 卡片（分类/参与/日期标签 + 标题 + 摘要）
      const acts = this.payload.yearActivities || this.payload.activities || [];
      const sessions = Number(this.kpis.activities) || acts.length;
      const participants = acts.reduce(
        (sum, a) => sum + (Number(a.participants) || 0),
        0
      );
      const peopleTag = (category, n) =>
        category === "三单服务" ? `服务 ${n} 人` : `参与 ${n} 人`;
      const peopleFallback = (category, n) =>
        category === "三单服务" ? `服务人数：${n}` : `参与人次：${n}`;
      const items = acts.map(a =>
        toDetailItem({
          title: a.title,
          content: a.content || peopleFallback(a.category, a.participants || 0),
          coverUrl: a.coverUrl,
          time: a.time,
          category: a.category || "",
          status:
            a.participants != null && a.participants !== ""
              ? peopleTag(a.category, a.participants)
              : a.status
        })
      );
      this.openDrawer({
        title: "年度活动列表",
        summary: [`场次：${sessions} 场`, `参与人次：${participants} 人`],
        items: items.length
          ? items
          : [
              toDetailItem({
                title: "暂无活动",
                content: "请在活动管理中按分类录入活动"
              })
            ]
      });
    },
    openVolunteerKpi() {
      // 口径 A：分月 + 按公益项目；弹层分两块展示
      const rows = this.volunteerAll || [];
      const hoursOf = v =>
        Math.max(0, Number(v.Num1 != null ? v.Num1 : v.num1) || 0);
      const atOf = v => {
        const raw = v.occurredAt || v.OccurredAt;
        if (!raw) return null;
        const d = new Date(raw);
        return Number.isNaN(d.getTime()) ? null : d;
      };

      const byMonth = {};
      const byProject = {};
      rows.forEach(v => {
        const h = hoursOf(v);
        if (!h) return;
        const d = atOf(v);
        const monthKey = d
          ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`
          : "未标注月份";
        byMonth[monthKey] = (byMonth[monthKey] || 0) + h;
        const project =
          String(v.title || v.Title || "其他项目").trim() || "其他项目";
        byProject[project] = (byProject[project] || 0) + h;
      });

      const monthTitle = key => {
        if (key === "未标注月份") return key;
        const parts = key.split("-");
        if (parts.length !== 2) return key;
        return `${parts[0]}年${Number(parts[1])}月`;
      };

      const monthItems = Object.keys(byMonth)
        .sort((a, b) => (a < b ? 1 : a > b ? -1 : 0))
        .map(m =>
          toDetailItem({
            title: monthTitle(m),
            status: `${byMonth[m]} 小时`,
            time: m === "未标注月份" ? "" : m,
            content: `该月公益服务累计 ${byMonth[m]} 小时`
          })
        );

      const projectItems = Object.keys(byProject)
        .sort((a, b) => byProject[b] - byProject[a])
        .map(t =>
          toDetailItem({
            title: t,
            status: `${byProject[t]} 小时`,
            content: `${t} 累计公益时长 ${byProject[t]} 小时`
          })
        );

      const total = Number(this.kpis.volunteerHours) || 0;
      const sections = [];
      if (monthItems.length) {
        sections.push({ title: "按月", items: monthItems });
      }
      if (projectItems.length) {
        sections.push({ title: "按项目", items: projectItems });
      }

      this.openDrawer({
        title: "公益时长统计",
        summary: [`累计 ${total} 小时`],
        sections: sections.length
          ? sections
          : [
              {
                title: "按项目",
                items: [
                  toDetailItem({
                    title: "暂无公益时长",
                    content: "请在「公益服务」台账中录入项目时长"
                  })
                ]
              }
            ]
      });
    },
    openServedKpi() {
      // 公益 / 三单统一卡片字段：分类 + 服务人数 + 日期 + 同款正文
      const volRows = this.volunteerAll || [];
      const sandanRows = this.payload.sandan || [];
      const n3 = row =>
        Math.max(0, Number(row.Num3 != null ? row.Num3 : row.num3) || 0);
      const dateOf = row =>
        (row.occurredAt || row.OccurredAt || row.time || "").toString().slice(0, 10);
      const mapServedItem = (row, fallbackTitle, category, extraStatus) => {
        const title = row.title || row.Title || fallbackTitle;
        const n = n3(row);
        const tags = [];
        if (extraStatus) tags.push(extraStatus);
        // 标题 / 服务人数已在标签区展示，正文只放台账说明，避免重复
        const note = String(row.content || row.Content || "").trim();
        return toDetailItem({
          title,
          category,
          status: `服务 ${n} 人`,
          statusTags: tags,
          time: dateOf(row),
          content: note
        });
      };

      const volItems = volRows
        .filter(v => n3(v) > 0)
        .map(v => mapServedItem(v, "公益项目", "公益"));

      const sandanItems = sandanRows
        .filter(s => n3(s) > 0)
        .map(s =>
          mapServedItem(
            s,
            "三单服务",
            "三单",
            s.status || s.Status || ""
          )
        );

      const sections = [];
      if (volItems.length) {
        sections.push({ title: "公益项目", items: volItems });
      }
      if (sandanItems.length) {
        sections.push({ title: "三单服务", items: sandanItems });
      }

      this.openDrawer({
        title: "服务群众明细",
        summary: [`累计服务 ${this.kpis.served || 0} 人`],
        sections: sections.length
          ? sections
          : [
              {
                title: "服务明细",
                items: [
                  toDetailItem({
                    title: "暂无服务人数",
                    content: "请在公益项目或三单台账中填写「服务人数」"
                  })
                ]
              }
            ]
      });
    },
    openSandanRate() {
      const list = this.payload.sandan || [];
      const st = this.payload.sandanStats || {};
      const isDone = s => {
        const t = s.status || s.Status || "";
        return (
          t.indexOf("已评单") >= 0 ||
          t.indexOf("已办结") >= 0 ||
          t.indexOf("已评价") >= 0
        );
      };
      const done = st.done != null ? st.done : list.filter(isDone).length;
      const pending =
        st.pending != null ? st.pending : Math.max(0, list.length - done);
      const rate = this.kpis.sandanRate || 0;
      const avgH = st.avgResponseHours;
      const satAvg = st.satisfactionAvg;
      const satRate = st.satisfactionRate;

      this.openDrawer({
        title: "三单办结统计",
        summaryLayout: "rows",
        summary: [
          { label: "已办结", value: `${done}` },
          { label: "待办结", value: `${pending}` },
          {
            label: "办结率",
            value: `${rate}%`,
            accent: true
          },
          {
            label: "平均响应时间",
            value: avgH != null && avgH !== "" ? `${avgH} 小时` : "—"
          },
          {
            label: "群众满意度",
            value:
              satAvg != null && satAvg !== ""
                ? `${satAvg} 星${satRate != null ? ` · ${satRate}%` : ""}`
                : "—"
          }
        ]
      });
    },
    openBrandKpi() {
      // 与思想页「品牌活动参与人数」同一弹层口径：当前视角品牌
      const brands = this.payload.brands || [];
      const items = brands.map(b => {
        const metrics = (b.metrics || [])
          .map(m => `${m.label} ${m.value}`)
          .join(" · ");
        return toDetailItem({
          title: b.name,
          category: `参与 ${b.participants || 0} 人次`,
          status: b.status || "进行中",
          content: metrics || "暂无分项指标",
          coverUrl: b.coverUrl
        });
      });
      this.openDrawer({
        title: "品牌活动参与明细",
        summary: [
          `合计 ${this.kpis.brandParticipants || 0} 人次`
        ],
        items: items.length
          ? items
          : [
              toDetailItem({
                title: "暂无品牌活动",
                content: "请在品牌活动台账按分会维护参与人数"
              })
            ]
      });
    },
    openVolunteer(v) {
      // 口径 A：弹本条公益台账详情（活动记录 / 照片 / 服务对象反馈），不挂子活动
      const title = v.title || v.Title || "公益项目";
      const time = (v.occurredAt || v.OccurredAt || "")
        .toString()
        .slice(0, 10);
      const hours = Number(v.Num1 != null ? v.Num1 : v.num1) || 0;
      const vols = Number(v.Num2 != null ? v.Num2 : v.num2) || 0;
      const served = Number(v.Num3 != null ? v.Num3 : v.num3) || 0;
      const record = String(v.content || v.Content || "").trim();
      const feedback = String(v.summary || v.Summary || "").trim();
      const thumbs = this.parseVolunteerPhotos(v);

      const sections = [
        {
          title: "活动记录",
          items: [
            toDetailItem({
              title: "",
              time,
              content: record || "暂无活动记录说明，请在后台填写"
            })
          ]
        },
        {
          title: "现场照片",
          items: [
            thumbs.length
              ? toDetailItem({
                  title: "",
                  content: "",
                  thumbs,
                  coverUrl: ""
                })
              : toDetailItem({
                  title: "",
                  content: "暂无照片，请在后台「现场照片」中上传"
                })
          ]
        },
        {
          title: "服务对象反馈",
          items: [
            toDetailItem({
              title: "",
              content: feedback || "暂无反馈，请在后台填写"
            })
          ]
        }
      ];

      this.openDrawer({
        title,
        summary: [
          `时长 ${hours} 小时`,
          `志愿者 ${vols} 人`,
          `服务 ${served} 人`
        ],
        sections
      });
    },
    parseVolunteerPhotos(v) {
      const raw = v.galleryText || v.GalleryText || "";
      return String(raw)
        .split(/[\r\n,;]+/)
        .map(s => s.trim())
        .filter(Boolean);
    },
    openCase(c) {
      const title = c.title || "三单案例";
      const orderTime = c.orderTime || c.time || "";
      const closeTime = c.closeTime || (c.isDone ? orderTime : "");
      const orderContent = c.orderContent || c.content || "";
      const dispatch = c.dispatchRecord || "";
      const result = c.result || "";
      const feedback = c.feedback || "";
      const rating = Number(c.rating) || 0;
      const thumbs = this.parseCasePhotos(c);

      const sections = [
        {
          title: "点单信息",
          items: [
            toDetailItem({
              title: "",
              status: c.status || "",
              content: orderContent || "暂无点单详情"
            })
          ]
        },
        {
          title: "流程留痕",
          items: [
            toDetailItem({
              title: "",
              content: dispatch || "暂无流程留痕，请在后台「流程留痕」填写"
            })
          ]
        },
        {
          title: "群众评价",
          items: [
            toDetailItem({
              title: "",
              rating,
              content:
                feedback ||
                (rating > 0
                  ? `群众满意度 ${rating} 星`
                  : "暂无群众评价（已评单后可填满意度与评价文字）")
            })
          ]
        },
        {
          title: "办理结果",
          items: [
            toDetailItem({
              title: "",
              content: result || "暂无办理结果"
            })
          ]
        },
        {
          title: "办理过程照片",
          items: [
            thumbs.length
              ? toDetailItem({
                  title: "",
                  content: "",
                  thumbs,
                  coverUrl: ""
                })
              : toDetailItem({
                  title: "",
                  content: "暂无办理过程照片"
                })
          ]
        }
      ];

      const summary = [`点单 ${orderTime || "—"}`];
      if (closeTime) summary.push(`办结 ${closeTime}`);
      if (c.author) summary.push(`接单 ${c.author}`);

      this.openDrawer({
        title,
        summary,
        sections
      });
    },
    enterpriseExpertLine(c) {
      const name = (c.expert || c.author || "服务专家").trim();
      const title = (c.expertTitle || c.expertise || "").trim();
      return title ? `${name} · ${title}` : name;
    },
    openEnterpriseCase(c) {
      const company = c.companyName || c.title || "助企案例";
      const demand = c.demand || c.content || "";
      const expert = c.expert || c.author || "";
      const expertTitle = c.expertTitle || c.expertise || "";
      const result = c.result || "";
      const feedback = c.feedback || "";
      const record = c.serviceRecord || c.dispatchRecord || "";
      const letter = c.feedbackLetterUrl || c.coverUrl || "";
      const thumbs = this.parseCasePhotos(c);
      const time = c.orderTime || c.time || "";

      const sections = [
        {
          title: "需求内容",
          items: [
            toDetailItem({
              title: "",
              content: demand || "暂无需求内容"
            })
          ]
        },
        {
          title: "服务记录",
          items: [
            toDetailItem({
              title: "",
              content: record || "暂无服务记录"
            })
          ]
        },
        {
          title: "企业盖章反馈函",
          items: [
            letter
              ? toDetailItem({
                  title: "",
                  content: "",
                  coverUrl: letter,
                  thumbs: []
                })
              : toDetailItem({
                  title: "",
                  content: "暂无反馈函，请在后台上传"
                })
          ]
        },
        {
          title: "现场服务照片",
          items: [
            thumbs.length
              ? toDetailItem({
                  title: "",
                  content: "",
                  thumbs,
                  coverUrl: ""
                })
              : toDetailItem({
                  title: "",
                  content: "暂无现场服务照片"
                })
          ]
        },
        {
          title: "解决结果",
          items: [
            toDetailItem({
              title: "",
              content: result || "暂无解决结果"
            })
          ]
        },
        {
          title: "企业反馈",
          items: [
            toDetailItem({
              title: "",
              content: feedback || "暂无企业反馈"
            })
          ]
        }
      ];

      const summary = [];
      if (time) summary.push(`服务 ${time}`);
      if (expert) {
        summary.push(
          expertTitle ? `专家 ${expert}（${expertTitle}）` : `专家 ${expert}`
        );
      }
      summary.push("科创青岛");

      this.openDrawer({
        title: company,
        summary,
        sections
      });
    },
    caseAvatarUrl(c) {
      return memberAvatarUrl({
        avatarUrl: c.avatarUrl || c.AvatarUrl
      });
    },
    caseAvatarStyle(c) {
      const url = this.caseAvatarUrl(c);
      if (url) {
        return { backgroundImage: `url(${url})` };
      }
      return {
        background: "linear-gradient(135deg, #1a4a8a, #0d6e6a)"
      };
    },
    parseCasePhotos(c) {
      const fromThumbs = (c.thumbs || [])
        .map(t => (typeof t === "string" ? t : t.coverUrl || t.url || ""))
        .filter(Boolean);
      if (fromThumbs.length) return fromThumbs;
      const cover = (c.coverUrl || c.CoverUrl || "").trim();
      return cover ? [cover] : [];
    },
    volAvatarUrl(v) {
      // 志愿者：优先会员头像，勿把活动封面当头像
      return memberAvatarUrl({
        avatarUrl: v.avatarUrl || v.AvatarUrl
      });
    },
    volAvatarStyle(v) {
      const url = this.volAvatarUrl(v);
      if (url) {
        return { backgroundImage: `url(${url})` };
      }
      return {
        background: "linear-gradient(135deg, #1a4a8a, #0d6e6a)"
      };
    },
    parseParticipantNames(text) {
      return String(text || "")
        .split(/[、,，;；|/\n\r]+/)
        .map(s => s.trim())
        .filter(Boolean);
    },
    parseMemberIds(text) {
      return String(text || "")
        .split(/[,，\s]+/)
        .map(s => parseInt(s.trim(), 10))
        .filter(n => !Number.isNaN(n) && n > 0);
    },
    volunteerEntryIncludesPerson(entry, person) {
      const name = String(person.name || person || "").trim();
      const memberId = person.memberId != null ? Number(person.memberId) : null;
      if (memberId) {
        const ids = this.parseMemberIds(
          entry.participantMemberIds || entry.ParticipantMemberIds
        );
        if (ids.includes(memberId)) return true;
        const authorId = entry.authorMemberId ?? entry.AuthorMemberId;
        if (Number(authorId) === memberId) return true;
      }
      const pt = entry.participantsText || entry.ParticipantsText || "";
      if (pt && name) {
        if (this.parseParticipantNames(pt).some(n => n === name)) return true;
      }
      const author = String(entry.author || entry.Author || "").trim();
      return !!name && author === name;
    },
    volunteerEntriesForPerson(person) {
      return (this.volunteerAll || [])
        .filter(e => this.volunteerEntryIncludesPerson(e, person))
        .slice()
        .sort((a, b) => {
          const ta = String(a.occurredAt || a.OccurredAt || "");
          const tb = String(b.occurredAt || b.OccurredAt || "");
          return tb.localeCompare(ta);
        });
    },
    volunteerStarCert(star) {
      const tiers = [
        { star: 1, hours: 100, title: "一星志愿者证书" },
        { star: 2, hours: 300, title: "二星志愿者证书" },
        { star: 3, hours: 600, title: "三星志愿者证书" },
        { star: 4, hours: 1000, title: "四星志愿者证书" },
        { star: 5, hours: 1500, title: "五星志愿者证书" }
      ];
      return tiers.filter(t => star >= t.star).pop() || null;
    },
    openVolunteerPerson(v) {
      const star = Math.max(0, Math.min(5, Number(v.star) || 0));
      const hours = Number(v.hours) || 0;
      const entries = this.volunteerEntriesForPerson(v);
      const cert = this.volunteerStarCert(star);

      const summary = [
        { label: "累计时长", value: `${hours} 小时` },
        { label: "参与项目", value: `${entries.length} 个` }
      ];

      const sections = [
        {
          title: "获得的星级证书",
          items: cert
            ? [
                toDetailItem({
                  title: cert.title,
                  highlight: `${cert.star}星`,
                  time: `累计 ${cert.hours}+ 小时`,
                  content: `累计公益服务时长达到 ${cert.hours} 小时，授予${cert.title}。`
                })
              ]
            : [
                toDetailItem({
                  title: "",
                  content: "暂未获得星级证书（累计 100 小时起评一星）"
                })
              ]
        },
        {
          title: "参加的公益项目",
          items: entries.length
            ? entries.map(e => {
                const sessionHours = Number(e.Num1 != null ? e.Num1 : e.num1) || 0;
                const served = Number(e.Num3 != null ? e.Num3 : e.num3) || 0;
                const record = String(e.content || e.Content || "").trim();
                return toDetailItem({
                  title: e.title || e.Title || "公益项目",
                  time: String(e.occurredAt || e.OccurredAt || "")
                    .slice(0, 10),
                  meta: `本场 ${sessionHours} 小时 · 服务 ${served} 人`,
                  content: record || "暂无活动记录说明"
                });
              })
            : [
                toDetailItem({
                  title: "",
                  content: "暂无公益项目记录，请在后台公益台账维护「本会志愿者」"
                })
              ]
        }
      ];

      this.openDrawer({
        title: `${v.name} · 个人公益档案`,
        summary,
        summaryLayout: "rows",
        sections
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10 / @rem2;
  min-height: 0;
}
.kpi-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10 / @rem2;
}
.kpi {
  min-height: 80 / @rem2;
  box-sizing: border-box;
  padding: 12 / @rem2 14 / @rem2;
  border: 1 / @rem2 solid fade(@mainColor, 35%);
  border-radius: 6 / @rem2;
  background: rgba(8, 28, 64, 0.55);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10 / @rem2;
  cursor: pointer;
  &__left {
    display: flex;
    align-items: center;
    gap: 10 / @rem2;
    min-width: 0;
  }
  &__icon-wrap {
    position: relative;
    width: 36 / @rem2;
    height: 36 / @rem2;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background: radial-gradient(
        circle,
        fade(@mainColor, 32%) 0%,
        fade(@mainColor, 8%) 50%,
        transparent 72%
      );
    }
  }
  &__icon-wrap--green::before {
    background: radial-gradient(
      circle,
      fade(#36d7b7, 36%) 0%,
      fade(#36d7b7, 8%) 50%,
      transparent 72%
    );
  }
  &__icon-wrap--rate::before {
    background: radial-gradient(
      circle,
      fade(#ff5a5a, 36%) 0%,
      fade(#ff5a5a, 8%) 50%,
      transparent 72%
    );
  }
  &__icon {
    position: relative;
    z-index: 1;
    font-size: 20 / @rem2;
    line-height: 1;
    color: #7ae7ff;
    filter: drop-shadow(0 0 4px fade(@mainColor, 65%));
  }
  &__icon-wrap--green .kpi__icon {
    color: #36d7b7;
    filter: drop-shadow(0 0 4px fade(#36d7b7, 65%));
  }
  &__icon-wrap--rate .kpi__icon {
    color: #ff7a7a;
    filter: drop-shadow(0 0 4px fade(#ff5a5a, 65%));
  }
  &__label {
    color: @assistColor;
    font-size: 14 / @rem2;
    white-space: nowrap;
  }
  b {
    font-size: 24 / @rem2;
    color: #fff;
    em {
      font-style: normal;
      font-size: 12 / @rem2;
      margin-left: 4 / @rem2;
      color: fade(#fff, 55%);
    }
  }
  &--green {
    border-color: fade(#36d7b7, 45%);
    b {
      color: #36d7b7;
    }
  }
}
.kpi--rate {
  .rate-ring {
    width: 56 / @rem2;
    height: 56 / @rem2;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      inset: 6 / @rem2;
      border-radius: 50%;
      background: rgba(6, 22, 52, 0.95);
    }
    strong {
      position: relative;
      z-index: 1;
      color: #fff;
      font-size: 14 / @rem2;
    }
  }
}
.cols {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10 / @rem2;
}
.col {
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10 / @rem2;
}
.col--mid {
  > .panel {
    flex: 1 1 0;
    min-height: 0;
    overflow: hidden;
  }
}
.col--right {
  > .panel {
    flex: 1 1 0;
    min-height: 0;
    overflow: hidden;
  }
}
.panel--vols {
  .vols-scroll {
    flex: 1;
    min-height: 0;
    height: 0;
    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
    }
    ::v-deep .el-scrollbar__bar {
      &.is-vertical {
        width: 6px;
        right: 2px;
      }
      &.is-horizontal {
        display: none;
      }
    }
    ::v-deep .el-scrollbar__thumb {
      background: rgba(100, 180, 255, 0.35);
      border-radius: 4px;
      &:hover {
        background: rgba(100, 180, 255, 0.55);
      }
    }
  }
}
.panel--cases {
  .cases-scroll {
    flex: 1;
    min-height: 0;
    height: 0;
    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
    }
    ::v-deep .el-scrollbar__bar {
      &.is-vertical {
        width: 6px;
        right: 2px;
      }
      &.is-horizontal {
        display: none;
      }
    }
    ::v-deep .el-scrollbar__thumb {
      background: rgba(100, 180, 255, 0.35);
      border-radius: 4px;
      &:hover {
        background: rgba(100, 180, 255, 0.55);
      }
    }
  }
}
.panel {
  padding: 12 / @rem2;
  border: 1 / @rem2 solid fade(@assistColor, 22%);
  border-radius: 6 / @rem2;
  background: rgba(6, 22, 52, 0.55);
  display: flex;
  flex-direction: column;
  min-height: 0;
  h3 {
    margin: 0 0 10 / @rem2;
    color: @mainColor;
    font-size: 16 / @rem2;
  }
}
.panel--cal {
  flex: 0 0 auto;
}
.panel--list {
  flex: 1;
  min-height: 0;
  max-height: 28%;
  overflow: hidden;
  .list-scroll {
    flex: 1;
    min-height: 0;
    height: 0;
    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden;
    }
    ::v-deep .el-scrollbar__bar {
      &.is-vertical {
        width: 6px;
        right: 2px;
      }
      &.is-horizontal {
        display: none;
      }
    }
    ::v-deep .el-scrollbar__thumb {
      background: rgba(100, 180, 255, 0.35);
      border-radius: 4px;
      &:hover {
        background: rgba(100, 180, 255, 0.55);
      }
    }
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0 8 / @rem2 0 0;
  }
  li {
    padding: 8 / @rem2 0;
    border-bottom: 1 / @rem2 solid fade(#fff, 8%);
    cursor: pointer;
    strong {
      display: block;
      color: #e8f3ff;
      font-size: 13 / @rem2;
    }
    span {
      color: fade(#36d7b7, 85%);
      font-size: 12 / @rem2;
    }
  }
}
.panel--chart {
  flex: 1;
  min-height: 0;
}
.chart {
  flex: 1;
  min-height: 140 / @rem2;
  width: 100%;
}
.trend-foot {
  margin: 6 / @rem2 0 0;
  text-align: center;
  color: fade(#fff, 55%);
  font-size: 12 / @rem2;
  line-height: 1.4;
}
.cal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6 / @rem2;
  h3 {
    margin: 0;
  }
  button {
    border: 0;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    width: 28 / @rem2;
    height: 28 / @rem2;
    border-radius: 4 / @rem2;
    cursor: pointer;
  }
}
.cal-legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6 / @rem2 10 / @rem2;
  margin-bottom: 6 / @rem2;
  span {
    display: inline-flex;
    align-items: center;
    gap: 4 / @rem2;
    color: fade(#fff, 55%);
    font-size: 10 / @rem2;
  }
  i {
    box-sizing: border-box;
    width: 8 / @rem2;
    height: 8 / @rem2;
    border-radius: 50%;
    background: transparent;
    border: 1.5 / @rem2 solid @mainColor;
    &.dot-blue {
      border-color: #00c3ff;
    }
    &.dot-green {
      border-color: #36d7b7;
    }
    &.dot-orange {
      border-color: #ff8a3d;
    }
    &.dot-red {
      border-color: #ff5a5a;
    }
    &.dot-purple {
      border-color: #b388ff;
    }
  }
}
.cal-week {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  color: fade(#fff, 45%);
  font-size: 11 / @rem2;
  margin-bottom: 4 / @rem2;
}
.cal-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2 / @rem2;
}
.cal-day {
  position: relative;
  height: 36 / @rem2;
  border: 0;
  background: transparent;
  color: #d7e6ff;
  font-size: 12 / @rem2;
  cursor: pointer;
  border-radius: 4 / @rem2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  &.empty {
    cursor: default;
  }
  &.today .cal-num {
    box-shadow: 0 0 0 1.5 / @rem2 #ff5a5a;
  }
  &.has .cal-num em {
    color: #fff;
    font-weight: 700;
  }
  &.active .cal-num {
    background: rgba(0, 195, 255, 0.22);
  }
  .cal-num {
    position: relative;
    width: 28 / @rem2;
    height: 28 / @rem2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
  em {
    position: relative;
    z-index: 2;
    font-style: normal;
    line-height: 1;
  }
  .cal-ring {
    position: absolute;
    border-radius: 50%;
    background: transparent;
    border: 2px solid @mainColor;
    /* 多层类型：外圈优先，向内同心收缩 */
    inset: calc(var(--i, 0) * 3px);
    z-index: 1;
    pointer-events: none;
    &.dot-blue {
      border-color: #00c3ff;
    }
    &.dot-green {
      border-color: #36d7b7;
    }
    &.dot-orange {
      border-color: #ff8a3d;
    }
    &.dot-red {
      border-color: #ff5a5a;
    }
    &.dot-purple {
      border-color: #b388ff;
    }
  }
}
.cases {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8 / @rem2;
  align-content: start;
  padding-right: 4 / @rem2;
  .empty {
    grid-column: 1 / -1;
  }
}
.case-card {
  position: relative;
  display: block;
  box-sizing: border-box;
  min-width: 0;
  height: 92 / @rem2;
  text-align: left;
  border: 1 / @rem2 solid fade(@mainColor, 28%);
  border-radius: 8 / @rem2;
  padding: 10 / @rem2 12 / @rem2;
  background: linear-gradient(
    135deg,
    rgba(0, 80, 150, 0.35) 0%,
    rgba(6, 22, 52, 0.55) 100%
  );
  color: #e8f3ff;
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transition: border-color 0.2s, background 0.2s;
  &:hover,
  &:focus,
  &:focus-visible {
    outline: none;
  }
  &:hover {
    border-color: fade(@mainColor, 55%);
    background: linear-gradient(
      135deg,
      rgba(0, 100, 180, 0.42) 0%,
      rgba(6, 28, 62, 0.62) 100%
    );
  }
  &__title {
    margin: 0 0 6 / @rem2;
    font-size: 14 / @rem2;
    font-weight: 600;
    line-height: 1.35;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-decoration: none;
  }
  &__member {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 6 / @rem2;
    margin-bottom: 6 / @rem2;
    overflow: hidden;
    min-width: 0;
  }
  &__avatar {
    width: 24 / @rem2;
    height: 24 / @rem2;
    border-radius: 50%;
    flex-shrink: 0;
    border: 1 / @rem2 solid fade(@mainColor, 40%);
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 11 / @rem2;
      font-weight: 600;
      color: fade(#fff, 92%);
      line-height: 1;
    }
  }
  &__name {
    font-size: 12 / @rem2;
    font-weight: 600;
    color: fade(#fff, 92%);
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__tag {
    font-style: normal;
    font-size: 10 / @rem2;
    padding: 1 / @rem2 6 / @rem2;
    border-radius: 3 / @rem2;
    background: fade(#36d7b7, 18%);
    color: #36d7b7;
    border: 1 / @rem2 solid fade(#36d7b7, 35%);
    flex-shrink: 0;
    max-width: 42%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__stars {
    color: #f5c542;
    font-size: 10 / @rem2;
    letter-spacing: 0.5px;
    line-height: 1;
    flex-shrink: 0;
    white-space: nowrap;
    &::before {
      content: "·";
      margin: 0 2 / @rem2;
      color: fade(#fff, 28%);
    }
  }
  &__result {
    margin: 0;
    padding-left: 8 / @rem2;
    border-left: 2 / @rem2 solid fade(@mainColor, 45%);
    font-size: 11 / @rem2;
    line-height: 1.45;
    color: fade(#fff, 62%);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &--gold {
    height: auto;
    min-height: 108 / @rem2;
    border-color: fade(#f5c542, 40%);
    background: linear-gradient(
      135deg,
      rgba(160, 120, 30, 0.28) 0%,
      rgba(6, 22, 52, 0.55) 100%
    );
    .case-card__title {
      padding-right: 56 / @rem2;
    }
    &:hover,
    &:focus-visible {
      border-color: fade(#f5c542, 72%);
      background: linear-gradient(
        135deg,
        rgba(200, 155, 50, 0.42) 0%,
        rgba(32, 22, 6, 0.62) 100%
      );
    }
    .case-card__result {
      border-left-color: fade(#f5c542, 45%);
    }
    .case-card__avatar {
      border-color: fade(#f5c542, 45%);
    }
  }
  .gold-tag {
    position: absolute;
    top: 8 / @rem2;
    right: 8 / @rem2;
    font-size: 10 / @rem2;
    padding: 2 / @rem2 6 / @rem2;
    border-radius: 3 / @rem2;
    background: rgba(245, 197, 66, 0.92);
    color: #2a1a00;
    z-index: 1;
  }
}
.ent-card {
  position: relative;
  display: block;
  box-sizing: border-box;
  min-width: 0;
  min-height: 118 / @rem2;
  text-align: left;
  border: 1 / @rem2 solid fade(#f5c542, 38%);
  border-radius: 8 / @rem2;
  padding: 10 / @rem2 12 / @rem2 8 / @rem2;
  background: linear-gradient(
    135deg,
    rgba(160, 120, 30, 0.28) 0%,
    rgba(6, 22, 52, 0.55) 100%
  );
  color: #e8f3ff;
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transition: border-color 0.2s, background 0.2s;
  &:hover,
  &:focus-visible {
    outline: none;
    border-color: fade(#f5c542, 72%);
    background: linear-gradient(
      135deg,
      rgba(200, 155, 50, 0.42) 0%,
      rgba(32, 22, 6, 0.62) 100%
    );
  }
  &__tag {
    position: absolute;
    top: 8 / @rem2;
    right: 8 / @rem2;
    font-size: 10 / @rem2;
    padding: 2 / @rem2 6 / @rem2;
    border-radius: 3 / @rem2;
    background: rgba(245, 197, 66, 0.92);
    color: #2a1a00;
    z-index: 1;
  }
  &__company {
    margin: 0 0 4 / @rem2;
    padding-right: 56 / @rem2;
    font-size: 13 / @rem2;
    font-weight: 600;
    line-height: 1.35;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__demand {
    margin: 0 0 4 / @rem2;
    font-size: 11 / @rem2;
    line-height: 1.4;
    color: fade(#fff, 72%);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__expert {
    margin: 0 0 4 / @rem2;
    font-size: 11 / @rem2;
    line-height: 1.35;
    color: fade(#f5c542, 92%);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__result {
    margin: 0 0 3 / @rem2;
    padding-left: 8 / @rem2;
    border-left: 2 / @rem2 solid fade(#f5c542, 45%);
    font-size: 11 / @rem2;
    line-height: 1.35;
    color: fade(#fff, 68%);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__feedback {
    margin: 0;
    font-size: 11 / @rem2;
    line-height: 1.35;
    color: fade(#f5c542, 88%);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.vols {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8 / @rem2;
  align-content: start;
  padding-right: 4 / @rem2;
  .empty {
    grid-column: 1 / -1;
  }
}
.vol-card {
  display: flex;
  gap: 8 / @rem2;
  align-items: center;
  min-width: 0;
  text-align: left;
  border: 1 / @rem2 solid fade(#fff, 10%);
  border-radius: 6 / @rem2;
  padding: 8 / @rem2 10 / @rem2;
  background: rgba(255, 255, 255, 0.06);
  color: #e8f3ff;
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  &--gold {
    border-color: fade(#f5c542, 55%);
    background: linear-gradient(
      90deg,
      rgba(180, 130, 40, 0.35),
      rgba(255, 255, 255, 0.06)
    );
  }
  &__avatar {
    width: 32 / @rem2;
    height: 32 / @rem2;
    border-radius: 50%;
    background: rgba(0, 195, 255, 0.28);
    background-size: cover;
    background-position: center;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    span {
      font-size: 13 / @rem2;
      font-weight: 600;
      color: fade(#fff, 92%);
      line-height: 1;
    }
  }
  &__body {
    min-width: 0;
    flex: 1;
    strong {
      display: block;
      font-size: 13 / @rem2;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  &__meta {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8 / @rem2;
    margin-top: 2 / @rem2;
    min-width: 0;
  }
  em {
    font-style: normal;
    font-size: 11 / @rem2;
    color: #36d7b7;
    flex-shrink: 0;
    white-space: nowrap;
  }
  .star-row {
    display: inline-flex;
    align-items: center;
    gap: 1 / @rem2;
    flex-shrink: 0;
    i {
      font-style: normal;
      color: fade(#fff, 25%);
      font-size: 11 / @rem2;
      line-height: 1;
      &.on {
        color: #f5c542;
      }
    }
  }
}
.panel--works {
  display: flex;
  flex-direction: column;
  .works {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
}
.works {
  position: relative;
  &__viewport {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    border-radius: 6 / @rem2;
  }
  &__track {
    display: flex;
    height: 100%;
    transition: transform 0.55s ease;
    will-change: transform;
  }
  &__slide {
    flex: 0 0 100%;
    width: 100%;
    min-width: 0;
    height: 100%;
    box-sizing: border-box;
    border: 0;
    padding: 0;
    background: transparent;
    cursor: pointer;
    text-align: left;
    display: flex;
    flex-direction: column;
  }
  &__img {
    flex: 1;
    min-height: 80 / @rem2;
    border-radius: 6 / @rem2;
    background-color: rgba(0, 80, 140, 0.4);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border: 1 / @rem2 solid fade(@mainColor, 30%);
  }
  &__cap {
    margin-top: 6 / @rem2;
    flex-shrink: 0;
    text-align: center;
    strong {
      display: block;
      color: #fff;
      font-size: 13 / @rem2;
    }
    span {
      color: fade(#fff, 55%);
      font-size: 12 / @rem2;
    }
  }
  &__dots {
    display: flex;
    justify-content: center;
    gap: 6 / @rem2;
    margin-top: 8 / @rem2;
    flex-shrink: 0;
    i {
      width: 6 / @rem2;
      height: 6 / @rem2;
      border-radius: 50%;
      background: fade(#fff, 25%);
      cursor: pointer;
      &.on {
        background: @mainColor;
      }
    }
  }
}
.empty {
  color: fade(#fff, 45%);
  font-size: 13 / @rem2;
}
.lb {
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: rgba(0, 0, 0, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  &__body {
    max-width: 70vw;
    text-align: center;
    img {
      max-width: 70vw;
      max-height: 75vh;
      object-fit: contain;
    }
    p {
      color: #fff;
      margin-top: 10 / @rem2;
    }
  }
  &__placeholder {
    width: 50vw;
    height: 40vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(20, 60, 110, 0.8);
    color: #fff;
    font-size: 20 / @rem2;
  }
  &__nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 48 / @rem2;
    height: 48 / @rem2;
    border: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    font-size: 28 / @rem2;
    cursor: pointer;
  }
  &__prev {
    left: 24 / @rem2;
  }
  &__next {
    right: 24 / @rem2;
  }
  &__close {
    position: absolute;
    top: 20 / @rem2;
    right: 28 / @rem2;
    border: 0;
    background: transparent;
    color: #fff;
    font-size: 32 / @rem2;
    cursor: pointer;
  }
}
</style>
